import { render, staticRenderFns } from "./CommunityOverview.vue?vue&type=template&id=2c6e0835&scoped=true&"
import script from "./CommunityOverview.vue?vue&type=script&lang=ts&"
export * from "./CommunityOverview.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityOverview.vue?vue&type=style&index=0&id=2c6e0835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e0835",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VDialog,VIcon,VSelect})
